export class SetModules {
  public static readonly type = '[Modules] Set modules';
  public constructor(public modules: any[]) {}
}

export class SetActiveModule {
  public static readonly type = '[Modules] Set active module';
  public constructor(public activeModule: any) {}
}
